/**
 * Created by Tukta on 15/7/2560.
 */
import React, { Component } from 'react'
import 'moment/locale/th';
import {connect} from 'react-redux';
import { Redirect } from 'react-router-dom'
import * as moment from 'moment';
import 'moment/locale/th';
import NumberFormat from 'react-number-format'

class DebtorsListRow extends Component{

    constructor (props){
        super(props)
        this.state = {
            'btnClick': '',
            'debtorsSelect': 0,
            debtors_id:'',
        }

    }

    toQueryString(paramsObject) {
        return Object
            .keys(paramsObject)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(paramsObject[key])}`)
            .join('&')
            ;
    }

    handleOnClick(action,debtors){

        var search = this.toQueryString (debtors);

        this.setState({
            'btnClick': action,
            'debtorsSelect': search,
            'debtors_id': debtors.debtors_id,
        });

    }

    render(){

        if (this.state.btnClick==="debtors-payment-detail") {
            var target = "/debtors/payment-detail/?debtors_id=" + this.state.debtors_id;
            return <Redirect push to={target}/>;
        }

        let sumRemain = 0;
        let sumPaid = 0;
        let sumDebt = 0;
        let debtorsList = this.props.debtors_list.map((debtors,index)=> {

            let remain =  debtors.amount_of_debt - debtors.amount_pay_sum ;
            sumRemain += parseFloat(remain)
            sumPaid += parseFloat(debtors.amount_pay_sum)
            sumDebt += parseFloat(debtors.amount_of_debt)

            return (
                <tr key={index}>
                    <td className="text-center">{index+1}</td>
                    <td className="text-left">
                      {debtors.debtors_name}
                      <br/>
                      {debtors.customer_name}  {debtors.customer_lastname}
                    </td>
                    <td className="text-center">
                        <NumberFormat value={remain}
                                      displayType={'text'}
                                      thousandSeparator={true}
                                      prefix={'฿'}/>
                    </td>
                    <td className="text-center">
                        <NumberFormat value={debtors.amount_pay_sum}
                                      displayType={'text'}
                                      thousandSeparator={true}
                                      prefix={'฿'}/>
                    </td>
                    <td className="text-center">
                        <NumberFormat value={debtors.amount_of_debt}
                                      displayType={'text'}
                                      thousandSeparator={true}
                                      prefix={'฿'}/>
                    </td>
                    <td className="text-center">
                      {debtors.fullname}
                      <br/>
                      {moment(debtors.updated_at).locale('th').format('DD-MM-YYYY HH:mm')}
                    </td>
                    <td className="text-right">

                        <button  onClick={()=>this.props.debtorsCallbacks.print(debtors)}
                                 type="button" className="btn btn-warning btn-sm btn-block">
                          <i className="icon-printer"> พิมพ์ใบผ่อนชำระ</i>
                        </button>

                        <button  onClick={()=>this.handleOnClick('debtors-payment-detail', debtors)}
                            type="button" className="btn btn-info btn-sm btn-block">
                            <i className="icon-list"> รายละเอียดชำระหนี้</i></button>

                        <button
                          onClick={()=>this.props.debtorsCallbacks.del(debtors)}
                          type="button"
                          className={this.props.user_type === 'admin'? "btn btn-danger btn-sm btn-block" : "hidden" }
                        >
                          <i className="icon-trash"> ลบรายการหนี้</i>
                        </button>

                    </td>
                </tr>
            )
        });

      console.log(sumDebt, sumPaid, sumRemain)
      let tbodySum = () => {
          return (
            <tr key="sum">
              <td className="text-right" colSpan={2}>
                <strong>&nbsp;รวม</strong>
              </td>
              <td className="text-center">
                <strong>
                <NumberFormat value={sumRemain}
                              displayType={'text'}
                              thousandSeparator={true}
                              prefix={'฿'}/>
                </strong>
              </td>
              <td className="text-left">
                <strong>
                  <NumberFormat value={sumPaid}
                                displayType={'text'}
                                thousandSeparator={true}
                                prefix={'฿'}/>
                </strong>
              </td>
              <td className="text-left">
                <strong>
                  <NumberFormat value={sumDebt}
                                displayType={'text'}
                                thousandSeparator={true}
                                prefix={'฿'}/>
                </strong>
              </td>
            </tr>
          )
      }

      let tbodyEmpty = ()=>{
        return (
          <tr className="text-center">
            <td colSpan={7}><span className="text-danger">ไม่พบข้อมูล</span></td>
          </tr>
        )};


        return (
            <div className="card-block">
                <table className="table table-striped">
                    <thead>
                    <tr>
                        <th className="text-center">#</th>
                        <th className="text-center">รายการ</th>
                        <th className="text-center">ยอดค้างชำระ</th>
                        <th className="text-center">ยอดเงินที่ชำระแล้ว</th>
                        <th className="text-center">ยอดหนี้</th>
                        <th className="text-center">ผู้บันทึกรายการ</th>
                        <th className="text-center">จัดการ</th>
                    </tr>
                    </thead>

                    <tbody>
                        {(debtorsList.length>0)? debtorsList: tbodyEmpty()}
                        {(debtorsList.length>0)? tbodySum(): null}
                    </tbody>

                </table>
                {/*<ul className="pagination">
                    <li className="page-item"><a className="page-link" href="#">Prev</a></li>
                    <li className="page-item active"><a className="page-link" href="#">1</a>
                    </li>
                    <li className="page-item"><a className="page-link" href="#">2</a></li>
                    <li className="page-item"><a className="page-link" href="#">3</a></li>
                    <li className="page-item"><a className="page-link" href="#">4</a></li>
                    <li className="page-item"><a className="page-link" href="#">Next</a></li>
                </ul>*/}
            </div>
        )
    }
}
const mapStateToProps = (state) => ({
    user: state.auth.user,
    token: state.auth.token,
    isAuthenticated: state.auth.isAuthenticated
})

export default connect(mapStateToProps)(DebtorsListRow);
